import { Kpi, KpiCalculationParams, KpiConfig, KpiConfigMeta, KPI_COMPONENTS } from '../../../../types';
import { format } from './kpi-formatter';

export class UnrealizedCostConfig implements KpiConfig {
  private id = KPI_COMPONENTS.UNREALIZED_COST as const;
  private title = 'Unrealized Cost';
  private type = 'currency';

  getMeta(): KpiConfigMeta {
    return {
      id: this.id,
      title: this.title,
      type: this.type,
    };
  }

  // FD-2927: sum the per-company `unrealizedCost` from the snapshot directly,
  // identical to the column the Companies Overview grid renders. Computing in
  // terms of `data` (rather than reading TOTAL_COST/REALIZED_COST out of the
  // shared `kpis` map) means this KPI is no longer sensitive to the order in
  // which other KPIs are registered in `KpiCalculator.kpisOrder`, and inherits
  // the backend's `Math.max(0, totalCost - realizedCost)` clamp for free so
  // FD-366 restructure-out semantics carry over without separate handling.
  calculate({ data }: KpiCalculationParams): Kpi {
    const value =
      data?.metrics?.reduce((total, metric) => total + Math.max(0, metric.unrealizedCost ?? 0), 0) ?? 0;

    return {
      ...this.getMeta(),
      value,
      formatted: format(value, this.type),
    };
  }
}
